import ListView from '../../../components/listView/ListView'
import Page from '../../../components/pageView/Page'

// Studio (30.03.08 slice 1): the owner's customization app. Every page here is
// the ordinary list and card framework over the model API's Studio routes.
const routesStudio = [
    {
        path: '/studio',
        element: Page,
        props: { type: 'modelStatusPage', options: { mode: 'edit', load: true } }
    },
    {
        path: '/studio/field',
        element: ListView,
        props: { type: 'modelFieldList' }
    },
    {
        path: '/studio/field/new',
        element: Page,
        props: { type: 'modelFieldPage', options: { mode: 'new', load: false } }
    },
    {
        path: '/studio/field/:id',
        element: Page,
        props: { type: 'modelFieldPage', options: { mode: 'edit', load: true } }
    },
    {
        path: '/studio/overlay',
        element: ListView,
        props: { type: 'modelOverlayList' }
    },
    {
        path: '/studio/overlay/new',
        element: Page,
        props: { type: 'modelOverlayPage', options: { mode: 'new', load: false } }
    },
    {
        path: '/studio/overlay/:id',
        element: Page,
        props: { type: 'modelOverlayPage', options: { mode: 'edit', load: true } }
    },
    {
        path: '/studio/version',
        element: ListView,
        props: { type: 'modelVersionList' }
    },
    {
        path: '/studio/version/:id',
        element: Page,
        props: { type: 'modelVersionPage', options: { mode: 'edit', load: true } }
    }
]

export default routesStudio
